module.exports = __webpack_public_path__ + "static/media/opensans-extrabold-webfont.47007265.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/opensans-extrabold-webfont.woff
// module id = 1024
// module chunks = 0